import { Button, ErrorState } from '@saniplus/ui';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router';

/**
 * The router's last resort.
 *
 * It never shows an error code and never shows a stack: a worker gets a plain
 * sentence and one concrete action (01-PRODUCT-SPEC §109). A 404 from the
 * router is the one case that gets its own words, because "ce lien ne mène
 * nulle part" is true and "une erreur est survenue" is not.
 *
 * The button does what it says: the dead link goes home, the unexpected
 * failure reloads. Both are hard navigations rather than `navigate()`, because
 * the boundary is standing exactly because the router failed.
 */
export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  const prefix = notFound ? 'errors.notFound' : 'errors.unexpected';

  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas p-6">
      <ErrorState
        title={t(`${prefix}.title`)}
        description={t(`${prefix}.body`)}
        action={
          <Button
            size="lg"
            onClick={() => {
              if (notFound) window.location.assign('/');
              else window.location.reload();
            }}
          >
            {t(`${prefix}.action`)}
          </Button>
        }
      />
    </div>
  );
}
